import { createUseStyles } from 'react-jss'

import { darkGrey } from '../../../../../../../../../../styles/const/colors'

const useStyles = createUseStyles({
  inventoryTypeTabsWrapper: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center'
  },
  totalValue: {
    color: darkGrey,
    fontSize: 14,
    lineHeight: '17px',
    fontWeight: 700
  },
  editPricesLink: {
    color: darkGrey
  }
})

export default useStyles
